import type { DocHandle } from "../sync/docManager";
import { useDocState } from "../core/useDocSelector";
import { useSession } from "./session";

/**
 * Whether this person may not change this workspace: the doc is read-only (no access, a newer schema), they
 * are a viewer in it, or a viewer profile. The one rule for views, Settings and the start page (before, Settings
 * checked only the doc, so a viewer could change shared settings).
 */
export function useReadOnly(handle: DocHandle | null, workspaceId: string | null): boolean {
  const docState = useDocState(handle);
  const role = useSession((s) => s.session?.workspaces?.find((w) => w.id === workspaceId)?.role);
  const kind = useSession((s) => s.session?.profile?.kind) ?? "person";
  return !handle || docState.readOnly || handle.readOnly || role === "viewer" || kind === "viewer";
}
